/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Sprite from '~components/Sprite'
import classNames from 'classnames'
import { displayPrice } from '~helpers/price'

const OrderAccordionItem = ({ productName, currency_code, items, toggle, expandPreference }) => {
  const [expanded, setExpanded] = useState(expandPreference)
  const [name, setName] = useState({})

  useEffect(() => setName(nameParts()), [productName])
  useEffect(() => setExpanded(expandPreference), [expandPreference])

  const nameParts = () => {
    const [styleCode, title, colour] = productName.split(' - ')
    return { styleCode, title, colour }
  }

  return (
    <>
      <div className="col-span-7 grid grid-cols-7 mt-4 bg-lightGrey border-coral border">
        <span className="p-3 md:p-4">
          {items[0].brand}
        </span>

        <span className="p-3 md:p-4">
          {name.title}
        </span>

        <span className="p-3 md:p-4">
          #
          {name.styleCode}
        </span>

        <span className="p-3 md:p-4">
          {name.colour}
        </span>

        <span className="p-3 md:p-4 ">
          {items.reduce((carry, item) => carry + item.quantity, 0)}
        </span>

        <span className="p-3 md:p-4">
          {displayPrice(items.reduce((carry, item) => carry + item.base_total, 0), currency_code)}
        </span>

        <span className="p-3 md:p-4">
          <button
            type="button"
            onClick={() => [setExpanded(!expanded), toggle()]}
            aria-label="Collapse"
            className="mx-auto block"
          >
            <span className="icon icon-fill block w-6 h-6" aria-hidden="true">
              <Sprite name={expanded ? 'minus' : 'plus'} />
            </span>
          </button>
        </span>
      </div>

      {expanded && (
        <div className="col-span-7 p-3 md:p-4 xl:p-6 mb-6 overflow-hidden border-coral border-b border-l border-r" aria-expanded="true">
          <div className="grid grid-cols-5 col-span-5 mb-3 items-center md:mb-4 xl:mb-6">
            <span className="px-3 md:px-4 xl:px-7 font-bold">
              Sku Number
            </span>

            <span className="px-3 md:px-4 xl:px-6 font-bold">
              Size
            </span>

            <span className="px-3 md:px-4 xl:px-6 font-bold">
              Qty
            </span>

            <span className="px-3 md:px-4 xl:px-6 font-bold">
              Unit price
            </span>

            <span className="px-3 md:px-4 xl:px-6 font-bold">
              Total unit price
            </span>
          </div>

          {items && (
            <div className="border border-coral">
              {items.map((item, index) => (
                <div
                  className={classNames(
                    'grid col-span-5 grid-cols-5 items-center',
                    { 'bg-pink': index % 2 !== 0 }
                  )}
                  key={item.id}
                >
                  <span className="p-3 md:p-4">
                    {item.sku}
                  </span>

                  <span className="p-3 md:p-4">
                    {item.product_options[0].display_value}
                  </span>

                  <span className="p-3 md:p-4">
                    {item.quantity}
                  </span>

                  <span className="p-3 md:p-4">
                    {displayPrice(item.base_price, currency_code)}
                  </span>

                  <span className="p-3 md:p-4">
                    {displayPrice(item.base_total, currency_code)}
                  </span>

                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  )
}

OrderAccordionItem.propTypes = {
  productName: PropTypes.string.isRequired,
  currency_code: PropTypes.string.isRequired,
  expandPreference: PropTypes.bool,
  items: PropTypes.array,
  toggle: PropTypes.func
}

export default OrderAccordionItem
